import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

export const canStartRescuePanelSplit = {
  name: "canStartRescuePanelSplit" as const,
  input: z.object({ teamId: zExt.objectId() }),
  output: z.object({
    canStartWithDefaultRescuePanel: z.boolean(),
    canStartWithSpotlight: z.boolean(),
  }),
};
